import { BASEAPIURL } from "./constants";
import Axios from "axios";

const api_url = process.env.REACT_APP_API_URL + "/";
const debugApi = process.env.REACT_APP_DEBUG_API === "1";
class Api {
  getBaseUrl() {
    return process.env.REACT_APP_API_URL ? api_url : BASEAPIURL;
  }
  getToken() {
    return localStorage.getItem("token");
  }

  getApi() {
    const axiosInstance = Axios.create({
      baseURL: this.getBaseUrl(),
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    axiosInstance.interceptors.response.use(
      (response) => {
        if (debugApi) {
          console.log("API Response:", {
            url: response.config.url,
            status: response.status,
          });
        }
        return response;
      },
      (error) => {
        console.log("API Error:", {
          url: error.config?.url,
          status: error.response?.status,
          message: error.message,
        });

        // 401 hatası geldiğinde kullanıcıyı logout yap ve login sayfasına yönlendir
        if (error?.response?.status === 401) {
          // Token geçersiz, localStorage'ı temizle
          localStorage.removeItem("token");
          localStorage.removeItem("permissions");

          // Login sayfasına yönlendir
          window.location.href = "/login";
        }

        return Promise.reject(error);
      }
    );

    return axiosInstance;
  }
  getApiWithoutToken() {
    const axiosInstance = Axios.create({
      baseURL: this.getBaseUrl(),
      headers: {
        Accept: "application/json",
      },
    });

    return axiosInstance;
  }
}
export default new Api();
